'use client';

import { type Key } from 'react';

import { Accordion } from '@backyard-ui/core';

import { formatCharacteristic } from '@/presenters/components/catalog/service/BuyBox/utils';

interface Characteristic {
  name: string;
  value: string;
}

interface TermsAccordionProps {
  characteristicsArray: Characteristic[];
}

export default function TermsAccordion(props: Readonly<TermsAccordionProps>) {
  const { characteristicsArray } = props;

  return (
    <Accordion.Root type="multiple" data-testid="terms-collapsible">
      {characteristicsArray.map((characteristic, index) => {
        const termsArray = formatCharacteristic(characteristic.value);

        return (
          <Accordion.Item key={index} value={`item-${index}`}>
            <Accordion.Header>
              <Accordion.Trigger>{characteristic.name}</Accordion.Trigger>
            </Accordion.Header>
            <Accordion.Content>
              <ul className="list-disc text-gray-600">
                {termsArray.map(
                  (item: string, index: Key | null | undefined) => (
                    <li key={index}>
                      <p>{item.trim()}</p>
                    </li>
                  )
                )}
              </ul>
            </Accordion.Content>
          </Accordion.Item>
        );
      })}
    </Accordion.Root>
  );
}
